// extracted by mini-css-extract-plugin
export default {"inboxFooter":"inboxFooter--f9b748abc42b844d590f"};